module.exports = __webpack_public_path__ + "img/SOF2022-2023annualreport.5be7ba5b.jpg";